/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RestructuringViewCell {
  rowNumber?: number;
  isEditable?: boolean;
  cellType?: RestructuringViewCellCellTypeEnum;
  content?: string | null;
  attributeId?: string | null;
  variableType?: RestructuringViewCellVariableTypeEnum | null;
  isDropdown?: boolean | null;
  displayType?: RestructuringViewCellDisplayTypeEnum;
  tooltip?: string | null;
  id?: string;
}
export enum RestructuringViewCellCellTypeEnum {
  Attribute = 'Attribute',
  Text = 'Text',
  Matrix = 'Matrix',
  Condition = 'Condition'
}
export enum RestructuringViewCellVariableTypeEnum {
  Text = 'Text',
  Number = 'Number',
  Date = 'Date',
  Boolean = 'Boolean',
  Country = 'Country',
  Currency = 'Currency',
  Percentage = 'Percentage'
}
export enum RestructuringViewCellDisplayTypeEnum {
  Default = 'Default',
  Result = 'Result',
  Invisible = 'Invisible'
}
